import { createContext } from "react";

// True inside a section shell. A page that renders its own <AppLayout> is then
// shown as section content only: no second sidebar, header, footer or CoPilot.
export const EmbeddedLayoutContext = createContext(false);
